// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pFCM","label":"styles_label__3jR9j"};